import { CapaQuotationServiceType } from '@generated/graphql';
import howToContents from './HowToContents';
import { CommonModalWrapper, ContentsItem } from './HowToModalCore';
import { CommonProps } from './types';

const HowToModal = ({
  open,
  onClose,
  type = CapaQuotationServiceType.Cnc
}: CommonProps) => {
  const howToContent = howToContents[type];

  if (!howToContent) return null;
  else {
    return (
      <CommonModalWrapper open={open} onClose={onClose}>
        {howToContent.map(({ title, description, examples }, index) => (
          <ContentsItem
            key={index}
            title={title}
            examples={examples}
            gutterBottom={index === howToContent.length - 1 ? 40 : 32}
          >
            {description}
          </ContentsItem>
        ))}
      </CommonModalWrapper>
    );
  }
};

export default HowToModal;
